// extracted by mini-css-extract-plugin
export var body = "_3a-1";
export var bodyPadded = "_3a-2";
export var chevron = "_3a-4";
export var chevronOpen = "_3a-5";
export var header = "_3a-0";
export var icon = "_3a-3";